import { navigateLinkToAgentPage, navigateLinkToClientPage } from 'Helpers/Navigation';
import fr from 'facet-rest';

export function navigateToManagedAccountPage(resource, isAgent = false, openInNewTab = false) {
  const link = resource.relationship(fr.relationships.managedAccountPage.name).link('related');

  if (isAgent) {
    navigateLinkToAgentPage(link, openInNewTab);
    return;
  }

  navigateLinkToClientPage(link, openInNewTab);
}
